enum PaymentMethod {
    CARD = 'card',
    CASH = 'cash',
    NONE = 'none',
}

export default PaymentMethod